import Event from ".";
import Addons from "./Addons";
import Checkout from "./Checkout";
import EventDetails from "./EventDetails";
import EventManage from "./EventManage";
import EventManageAi from "./EventManageAi";
import MyEvent from "./MyEvent";
import Publish from "./Publish";
import Thankyou from "./Thankyou";
import Ticket from "./Ticket";
import TicketManage from "./TicketManage";
import TicketsOrderSummary from "./TicketsOrderSummary";

import UserEvents from "./UserEvents";

export const eventRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"
  const global_routes = [
    {
      path: "/:lang/user/events",
      title: "Event",
      layout: "user",
      routeType: "organization",
      component: UserEvents,
    },
    {
      path: "/:lang/order-summary/:eventId",
      title: "Order Summary",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: TicketsOrderSummary,
    },
    {
      path: "/:lang/checkout/:eventId",
      title: "Checkout",
      layout: "front",
      component: Checkout,
    },
    {
      path: "/:lang/thank-you",
      title: "Thank You",
      layout: "front",
      component: Thankyou,
    },
    {
      path: "/:lang/events",
      title: "Events",
      layout: "front",
      component: Event,
    },
    {
      path: "/:lang/event-details/:eventId",
      title: "Event-details",
      layout: "front",
      component: EventDetails,
    },
  ];

  if (user_role_in_org === "promoter") {
    return global_routes;
  } else {
    return [
      ...global_routes,
      {
        path: "/:lang/user/events/event-manage",
        title: "Event-manage",
        layout: "user",
        routeType: "organization",
        component: EventManage,
      },
      {
        path: "/:lang/user/events/event-manage-ai",
        title: "Event-manage",
        layout: "user",
        routeType: "organization",
        component: EventManageAi,
      },
      {
        path: "/:lang/user/events/manage-ticket/:eventId",
        title: "Ticket-manage",
        layout: "user",
        routeType: "organization",
        component: Ticket,
      },
      {
        path: "/:lang/user/events/manage-ticket/:eventId/:ticketId",
        title: "Ticket-manage",
        layout: "user",
        routeType: "organization",
        component: Ticket,
      },
      {
        path: "/:lang/user/events/manage-addons/:eventId",
        title: "Addons-manage",
        layout: "user",
        routeType: "organization",
        component: Addons,
      },
      {
        path: "/:lang/user/events/manage-addons/:eventId/:addonsId",
        title: "v",
        layout: "user",
        routeType: "organization",
        component: Addons,
      },
      {
        path: "/:lang/user/events/tickets/:eventId",
        title: "Tickets",
        layout: "user",
        routeType: "organization",
        component: TicketManage,
      },
      {
        path: "/:lang/user/events/event-manage/:eventId",
        title: "Event-manage",
        layout: "user",
        routeType: "organization",
        component: EventManage,
      },
      {
        path: "/:lang/user/events/publish/:eventId",
        title: "Publish",
        layout: "user",
        routeType: "organization",
        component: Publish,
      },
      {
        path: "/:lang/user/myEvent/:eventId",
        title: "My Event",
        layout: "frontUserInner",
        routeType: "organization",
        component: MyEvent,
      },
    ];
  }
};
